





































import { hideLoading, showLoading } from '@tencent/wphk-components-loading';
import { getServerDate } from '@/util/dateHelper';
import { CustomException, elk, language, util } from '@tencent/ppd-base-libs';
// import { EkycStatus } from '@tencent/wphk-act-base-cgi';
import { hideDialog, showDialog } from '@tencent/wphk-components-dialog';
import {
  biReport,
  ExtType,
  PromoteZoneUserStatus,
  setPrefix,
} from '@tencent/wphk-components-discount-code/business/bi';
import {
  ActState,
  codeAct,
  CodeAct,
} from '@tencent/wphk-components-discount-code/business/codeAct';
import { couponModule } from '@tencent/wphk-components-discount-code/business/coupon';
import {
  getAllValidDiscountCodeConfig,
  getDiscountAward,
  init,
  queryCouponsByCode,
} from '@tencent/wphk-components-discount-code/business/index';
import { getDiscountCodeInfoFromCfg } from '@tencent/wphk-components-discount-code/business/merchantCfg';
import {
  isUseTipsMark,
  // setUseTipsMark,
} from '@tencent/wphk-components-discount-code/business/useTipsMark';
import CodeInput from '@tencent/wphk-components-discount-code/components/code-input.vue';
import Title from '@tencent/wphk-components-discount-code/components/common/title.vue';
import DiscountCodeAct from '@tencent/wphk-components-discount-code/components/discount-code-act.vue';
import NewUserCouponRewardCard from '@tencent/wphk-components-discount-code/components/new-user-coupon-reward/new-user-coupon-reward-card.vue';
import NewUserCouponRewardDialog from '@tencent/wphk-components-discount-code/components/new-user-coupon-reward/new-user-coupon-reward-dialog.vue';
// import { showEkycDialog } from '@tencent/wphk-components-discount-code/components/ekyc-tips/business';
import EkycTips from '@tencent/wphk-components-discount-code/components/ekyc-tips/index.vue';
import TncIcon from '@tencent/wphk-components-discount-code/components/tnc-icon/index.vue';
import UseTips from '@tencent/wphk-components-discount-code/components/use-tips.vue';
import { i18n as i18nLocal } from '@tencent/wphk-components-discount-code/i18n';
import {
  AwardType,
  CouponState,
  CustomJumpType,
  DiscountCodeCfg,
  DiscountCodeErr,
  DiscountCodeErrMsg,
  DiscountCodeInfo,
} from '@tencent/wphk-components-discount-code/types';
import { toCouponDetailOrList } from '@tencent/wphk-components-discount-code/utils';
import { isEmpty } from 'lodash-es';
import moment from 'moment';
import { Component, Ref, Vue, Watch } from 'vue-property-decorator';

@Component({
  components: {
    CodeInput,
    DiscountCodeAct,
    UseTips,
    Title,
    EkycTips,
    TncIcon,
    NewUserCouponRewardDialog,
    NewUserCouponRewardCard,
  },
})
export default class DiscountCode extends Vue {
  @Ref('codeInput') public codeInput!: CodeInput;
  @Ref('useTips') public useTips!: UseTips;

  public isShow = false;
  public titleConfig = {
    title: i18nLocal('迎新獎賞'),
  };

  public codeAct: CodeAct = codeAct;

  public couponModule = couponModule;

  public discountCodeInfo: DiscountCodeInfo = {
    mrchId: '',
    // 商户名
    mrchName: '',
    // 优惠码
    code: '',
    // 优惠码活动是否过期
    isExpired: true,
    rank: '',
    mrchLogo: '',
    customJumpType: CustomJumpType.DEFAULT,
  };

  public isCouponRewardDialogShow = false;

  get enLangClass() {
    return language.getLanguage() === 'en' ? 'discount-code-en' : '';
  }

  // bi上报基础字段
  public get biExt() {
    let status;
    if (this.codeAct.canSwitch) {
      status = PromoteZoneUserStatus.SWITCH_RECEIVE;
    } else if (!!this.codeAct.awardCode) {
      status = PromoteZoneUserStatus.RECEIVED;
    } else {
      status = PromoteZoneUserStatus.UNRECEIVED;
    }
    return {
      promotezoneuserstatus: status,
    };
  }

  // 输入的优惠码
  public code = '';

  public get couponInfo() {
    return {
      ...couponModule.discountCodeCoupon,
    };
  }

  public handleToUseBtn() {
    this.biReportBase('usebtn_click', {
      promotecode: this.codeAct.awardCode,
    });
    toCouponDetailOrList(this.couponInfo, 'promzone');
  }

  public get isShowDesc() {
    return this.couponInfo.state !== CouponState.received;
  }

  public get actState() {
    return this.codeAct.actState;
  }

  public checkIsShow(validDiscountCodeConfig: DiscountCodeCfg[]) {
    console.log(
      '===codeAct',
      this.codeAct,
      this.couponInfo.state,
      validDiscountCodeConfig,
    );
    // 用户领取的奖品如果是消费券，判断消费券是否过期 过期的话不展示
    if (this.codeAct.awardType === AwardType.CV) {
      const cv = this.codeAct.getUserCVItem();
      const curTime = getServerDate().getTime();
      const cvExpireTime = moment(cv?.expireTime).valueOf();
      return curTime <= cvExpireTime;
    }
    // 优惠券相关的
    /** 是否符合：满足条件未领取 */
    const canJoinAct = [ActState.UNRECEIVED, ActState.RECEIVING].includes(this.actState);
    const hasValidConfig = !isEmpty(validDiscountCodeConfig);
    const isCouponAvaliable = this.couponInfo.state === CouponState.received;
    return (canJoinAct && hasValidConfig) || isCouponAvaliable;
  }
  // 判断用户奖品类型
  public get isCv() {
    return this.codeAct.awardType === AwardType.CV;
  }
  public get isShowInput() {
    return (
      this.actState === ActState.UNRECEIVED
      || this.actState === ActState.RECEIVING
    );
  }

  public get isShowCoupon() {
    return this.actState === ActState.RECEIVED;
  }

  public get isReceivingGetOther() {
    return (
      this.actState === ActState.RECEIVING
      && this.codeAct.awardCode !== this.code
    );
  }

  @Watch('isShow')
  public handleBrowReport(newVal, oldVal) {
    if (newVal && newVal !== oldVal) {
      this.biReportBase('promotecode_brow');
    }
  }

  // 封装bi上报
  public biReportBase(str: string, ext?: ExtType) {
    biReport(str, {
      ...this.biExt,
      ...ext,
    });
  }

  public showErrTip(msg: string, code: string) {
    this.biReportBase('error_brow', {
      error: msg,
      promotecode: code,
    });
    showDialog({
      content: msg,
      btns: [
        {
          text: i18nLocal('我知道了'),
          click: hideDialog,
        },
      ],
    });
  }

  /** 点击确认按钮 */
  public async onClickConfirmBtn(value: string) {
    this.biReportBase('promotecodeconfirm_click', {
      promotecode: value,
    });
    // @TAPD 884507091 暂时关闭ekyc
    // // 如果没通过ekyc，则展示ekyc弹窗
    // if (this.codeAct.ekycStatus !== EkycStatus.pass) {
    //   showEkycDialog({ ekycStatus: this.codeAct.ekycStatus });
    //   return;
    // }
    // 如果没填优惠码，则展示错误弹窗
    if (!value) {
      this.showErrTip(DiscountCodeErrMsg.EmptyCodeErr, value);
      return;
    }
    this.handleQuery(value);
  }

  /** 进行查询优惠码 */
  public async handleQuery(value: string) {
    // 先从前端配置中过滤不合格的code
    const [, cfgInfo] = await util.to(getDiscountCodeInfoFromCfg(value));
    if (!cfgInfo) {
      this.showErrTip(DiscountCodeErrMsg.CodeNoFind, value);
      return;
    }
    this.discountCodeInfo = cfgInfo;
    // 如果过期了
    if (this.discountCodeInfo.isExpired) {
      this.showErrTip(DiscountCodeErrMsg.OutOfStock, value);
      return;
    }
    // 从后台获取code的映射
    const [err] = await util.to(queryCouponsByCode(value, false));
    if (err) {
      if (err.name === DiscountCodeErr.CodeNoFind) {
        this.showErrTip(DiscountCodeErrMsg.CodeNoFind, value);
        return;
      }
      throw new CustomException(
        null,
        'QueryCouponsByCodeFail',
        '查询优惠码报错',
      );
    }
    this.code = value;

    if (this.isReceivingGetOther || this.actState === ActState.RECEIVED) {
      this.showErrTip(DiscountCodeErrMsg.RepeatGot, value);
      return;
    }
    this.isCouponRewardDialogShow = true;
    // console.trace('=============== 优惠码券信息 ==========', {
    //   couponInfo: this.couponInfo,
    //   couponModule,
    //   value,
    //   codeAct: this.codeAct.codeAndActMap.find(item => item.awardCode === value),
    // });
    // 领取弹窗曝光
    this.biReportBase('confirmpopup_brow', {
      promotecode: value,
    });
  }

  public onTipsClick() {
    this.biReportBase('howtousebtn_click', {
      promotecode: this.code,
    });
  }

  public onTipsGo() {
    this.biReportBase('howtousebtn_popupbtn_click', {
      promotecode: this.code,
      usepopup: !isUseTipsMark ? 'use' : 'howtouse',
    });
  }

  public async handleRedeemCoupon() {
    this.biReportBase('confirmpopup_confirmbtn_click', {
      promotecode: this.code,
    });
    await this.handleReceive();
  }

  public async handleViewCoupon() {
    this.biReportBase('successpopup_viewcoupons_click', {
      promotecode: this.code,
    });
    // 领取成功弹窗[查看优惠券]按钮：查看跳列表或者券详情
    return toCouponDetailOrList(this.couponInfo, 'promzone');
  }

  public handleCancel() {
    this.isCouponRewardDialogShow = false;
  }

  public async handleReceive() {
    showLoading();
    const [err] = await util.to(getDiscountAward(this.code));
    hideLoading();
    if (err) {
      let msg = DiscountCodeErrMsg.ReceiveFail;
      if (Object.keys(DiscountCodeErrMsg).includes(err.name)) {
        msg = DiscountCodeErrMsg[err.name];
      }
      this.showErrTip(msg, this.code);
      throw new CustomException(
        null,
        'handleReceiveFail',
        `领取优惠码失败:${err.name}`,
      );
    }
    this.biReportBase('successpopup_brow', {
      promotecode: this.code,
    });
  }

  public async created() {
    // 初始化上报前缀
    setPrefix('promotion.welcomeoffer.promotezone');
    const [err, ret] = await util.to(Promise.all([init(), getAllValidDiscountCodeConfig()]));
    if (err) {
      throw new CustomException(
        err,
        'DiscountCodeInitFail',
        '优惠码模块初始化失败',
      );
    }
    this.isShow = this.checkIsShow(ret?.[1]);
    // 优惠码曝光
    elk({
      key: 'discountCodeBrow',
      str2: `isShow:${this.isShow}`,
      str3: `isShowInput:${this.isShowInput}`,
      str4: `isShowCoupon:${this.isShowCoupon}`,
    });
  }
}
